import { mapGetters } from 'vuex';
import bizTransport from '@/modules/bizTransport';

export default {
  data() {
    return {
      consolebizTransport: null
    };
  },
  computed: {
    ...mapGetters(['logTransportToken'])
  },
  methods: {
    // add console log transport
    addLogTransport() {
      this.consolebizTransport = new bizTransport(this.logTransportToken);
      this.$logger.add(this.consolebizTransport);
    },

    // remove console log transport
    removeLogTransport() {
      this.$logger.remove(this.consolebizTransport);
    }
  }
};
